import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ObjectUtils } from 'src/app/@core/utils/object-utils';
import { OnbaseCatalogue } from 'src/app/models/onbase-catalogue';
import { OnbaseService } from 'src/app/services/onbase.service';

@Component({
  selector: 'app-pos-credit-request-company-contact-information-modal',
  templateUrl: './pos-credit-request-company-contact-information-modal.component.html',
  styleUrls: ['./pos-credit-request-company-contact-information-modal.component.sass']
})
export class PosCreditRequestCompanyContactInformationModalComponent implements OnInit {

  //onbaseCatalogue: OnbaseCatalogue = new OnbaseCatalogue();
  contactPositions: Array<{ key: string, value: string }> = [];
  constructor(private bsModalRef: BsModalRef, private onbaseService: OnbaseService) {

  }
  confirmAction: (form: FormGroup) => any = () => { };
  async ngOnInit(): Promise<void> {
    let onbaseCatalogue = (await this.onbaseService.readOnBaseCatalogue().toPromise()).response;
    this.contactPositions = ObjectUtils.objectToArray(onbaseCatalogue.businessPosition);
  }

  form: FormGroup = new FormGroup({
    firstName: new FormControl("", Validators.required),
    middleName: new FormControl(""),
    lastName: new FormControl("", Validators.required),
    secondLastName: new FormControl(""),
    contactPosition: new FormControl("", Validators.required),
    mobilePhone: new FormControl("", Validators.required),
    phone: new FormControl("", Validators.required),
    phoneExtension: new FormControl(""),
    email: new FormControl("", [Validators.required, Validators.email]),
  });
  confirm() {
    this.confirmAction(this.form);
    this.close();
  }
  close() {
    this.bsModalRef.hide();
  }
  draft() {
    this.confirmAction(this.form);
    this.close();
  }
}
